<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Imprimir listados</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación</span>
      <span> /</span>
      <span>Imprimir listados</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row pt-3 pb-1 pl-0">
      <div class="col" style="max-width: 170px;">
        <h5>Tipo de listado:</h5>
      </div>
      <div
        class="col dato"
        style="min-width: 350px; display: flex; align-items: center;"
      >
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline" style="margin-right: 20px;">
          <input
            type="radio"
            class="form-check-input"
            id="materialInline1"
            name="inlineMaterialRadiosExample"
            mdbInput
          />
          <label class="form-check-label" for="materialInline1">Carga</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input
            type="radio"
            class="form-check-input"
            id="materialInline2"
            name="inlineMaterialRadiosExample"
            mdbInput
          />
          <label class="form-check-label" for="materialInline2">Cobranza</label>
        </div>
      </div>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 300px;">
        <div class="md-form mb-0">
          <input
            value=""
            type="text"
            id="nroRecorrido"
            class="form-control"
            placeholder="Nro de recorrido"
            required
            #nroRecorrido
          />
          <label for="nroRecorrido">Filtrar por recorrido</label>
        </div>
      </div>
      <div class="col d-flex" style="max-width: 300px;">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarRecorrido.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents;">
          Recorrido seleccionado
        </h6>
      </div>
      <div class="col">
        <mdb-checkbox>Todos los recorridos del día</mdb-checkbox>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" class="btn btn-sm" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle mb-5">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox></mdb-checkbox></th>
            <th></th>
            <th scope="col">Nro. Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Chofer</th>
            <th scope="col">Monto a cobrar</th>
            <th scope="col">Documentos</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr></tr>
          <tr></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Imprimir
    </button>
  </div>
</div>

<!-- MODAL seleccionarRecorrido -->
<div
  mdbModal
  #seleccionarRecorrido="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar recorrido
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarRecorrido.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="descRecorrido"
                class="form-control"
                placeholder="Descripción o Código"
                required
                #descRecorrido
              />
              <label for="descRecorrido">Chofer o Código de recorrido</label>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-between"
          style="border-top: 1px solid #dee2e6;"
        >
          <div></div>
          <button mdbBtn type="button" color="info" mdbWavesEffect>
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>

        <table
          class="table table-striped table-hover table-sm align-middle mt-1"
        >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Descripción</th>
              <th scope="col">Chofer</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>21323123</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>0105234234</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1111133333</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
